function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function is_empty(obj) {
  return Object.keys(obj).length === 0;
} // Track which nodes are claimed during hydration. Unclaimed nodes can then be removed from the DOM
// at the end of hydration without touching the remaining nodes.


var is_hydrating = false;

function start_hydrating() {
  is_hydrating = true;
}

function end_hydrating() {
  is_hydrating = false;
}

function upper_bound(low, high, key, value) {
  // Return first index of value larger than input value in the range [low, high)
  while (low < high) {
    var mid = low + (high - low >> 1);

    if (key(mid) <= value) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }

  return low;
}

function init_hydrate(target) {
  if (target.hydrate_init) return;
  target.hydrate_init = true; // We know that all children have claim_order values since the unclaimed have been detached

  var children = target.childNodes;
  /*
  * Reorder claimed children optimally.
  * We can reorder claimed children optimally by finding the longest subsequence of
  * nodes that are already claimed in order and only moving the rest. The longest
  * subsequence subsequence of nodes that are claimed in order can be found by
  * computing the longest increasing subsequence of .claim_order values.
  *
  * This algorithm is optimal in generating the least amount of reorder operations
  * possible.
  *
  * Proof:
  * We know that, given a set of reordering operations, the nodes that do not move
  * always form an increasing subsequence, since they do not move among each other
  * meaning that they must be already ordered among each other. Thus, the maximal
  * set of nodes that do not move form a longest increasing subsequence.
  */
  // Compute longest increasing subsequence
  // m: subsequence length j => index k of smallest value that ends an increasing subsequence of length j

  var m = new Int32Array(children.length + 1); // Predecessor indices + 1

  var p = new Int32Array(children.length);
  m[0] = -1;
  var longest = 0;

  for (var i = 0; i < children.length; i++) {
    var current = children[i].claim_order; // Find the largest subsequence length such that it ends in a value less than our current value
    // upper_bound returns first greater value, so we subtract one

    var seqLen = upper_bound(1, longest + 1, function (idx) {
      return children[m[idx]].claim_order;
    }, current) - 1;
    p[i] = m[seqLen] + 1;
    var newLen = seqLen + 1; // We can guarantee that current is the smallest value. Otherwise, we would have generated a longer sequence.

    m[newLen] = i;
    longest = Math.max(newLen, longest);
  } // The longest increasing subsequence of nodes (initially reversed)


  var lis = []; // The rest of the nodes, nodes that will be moved

  var toMove = [];
  var last = children.length - 1;

  for (var cur = m[longest] + 1; cur != 0; cur = p[cur - 1]) {
    lis.push(children[cur - 1]);

    for (; last >= cur; last--) {
      toMove.push(children[last]);
    }

    last--;
  }

  for (; last >= 0; last--) {
    toMove.push(children[last]);
  }

  lis.reverse(); // We sort the nodes being moved to guarantee that their insertion order matches the claim order

  toMove.sort(function (a, b) {
    return a.claim_order - b.claim_order;
  }); // Finally, we move the nodes

  for (var _i = 0, j = 0; _i < toMove.length; _i++) {
    while (j < lis.length && toMove[_i].claim_order >= lis[j].claim_order) {
      j++;
    }

    var anchor = j < lis.length ? lis[j] : null;
    target.insertBefore(toMove[_i], anchor);
  }
}

function append(target, node) {
  if (is_hydrating) {
    init_hydrate(target);

    if (target.actual_end_child === undefined || target.actual_end_child !== null && target.actual_end_child.parentElement !== target) {
      target.actual_end_child = target.firstChild;
    }

    if (node !== target.actual_end_child) {
      target.insertBefore(node, target.actual_end_child);
    } else {
      target.actual_end_child = node.nextSibling;
    }
  } else if (node.parentNode !== target) {
    target.appendChild(node);
  }
}

function insert(target, node, anchor) {
  if (is_hydrating && !anchor) {
    append(target, node);
  } else if (node.parentNode !== target || anchor && node.nextSibling !== anchor) {
    target.insertBefore(node, anchor || null);
  }
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function destroy_each(iterations, detaching) {
  for (var i = 0; i < iterations.length; i += 1) {
    if (iterations[i]) iterations[i].d(detaching);
  }
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_style(node, key, value, important) {
  node.style.setProperty(key, value, important ? 'important' : '');
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

var flushing = false;
var seen_callbacks = new Set();

function flush() {
  if (flushing) return;
  flushing = true;

  do {
    // first, call beforeUpdate functions
    // and update components
    for (var i = 0; i < dirty_components.length; i += 1) {
      var component = dirty_components[i];
      set_current_component(component);
      update(component.$$);
    }

    set_current_component(null);
    dirty_components.length = 0;

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var _i2 = 0; _i2 < render_callbacks.length; _i2 += 1) {
      var callback = render_callbacks[_i2];

      if (!seen_callbacks.has(callback)) {
        // ...so guard against infinite loops
        seen_callbacks.add(callback);
        callback();
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
  flushing = false;
  seen_callbacks.clear();
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing["delete"](block);
    block.i(local);
  }
}

function mount_component(component, target, anchor, customElement) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor);

  if (!customElement) {
    // onMount happens before the initial afterUpdate
    add_render_callback(function () {
      var new_on_destroy = on_mount.map(run).filter(is_function);

      if (on_destroy) {
        on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
      } else {
        // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        run_all(new_on_destroy);
      }

      component.$$.on_mount = [];
    });
  }

  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : options.context || []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty,
    skip_bound: false
  };
  var ready = false;
  $$.ctx = instance ? instance(component, options.props || {}, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      start_hydrating();
      var nodes = children(options.target); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor, options.customElement);
    end_hydrating();
    flush();
  }

  set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 */


var SvelteComponent = /*#__PURE__*/function () {
  function SvelteComponent() {
    _classCallCheck(this, SvelteComponent);
  }

  _createClass(SvelteComponent, [{
    key: "$destroy",
    value: function $destroy() {
      destroy_component(this, 1);
      this.$destroy = noop;
    }
  }, {
    key: "$on",
    value: function $on(type, callback) {
      var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
      callbacks.push(callback);
      return function () {
        var index = callbacks.indexOf(callback);
        if (index !== -1) callbacks.splice(index, 1);
      };
    }
  }, {
    key: "$set",
    value: function $set($$props) {
      if (this.$$set && !is_empty($$props)) {
        this.$$.skip_bound = true;
        this.$$set($$props);
        this.$$.skip_bound = false;
      }
    }
  }]);

  return SvelteComponent;
}();
/* src\Circle.svelte generated by Svelte v3.38.3 */


function add_css$n() {
  var style = element("style");
  style.id = "svelte-14upwad-style";
  style.textContent = ".circle.svelte-14upwad{height:var(--size);width:var(--size);border-color:var(--color) transparent var(--color) var(--color);border-width:calc(var(--size) / 15);border-style:solid;border-image:initial;border-radius:50%;animation:var(--duration) linear 0s infinite normal none running svelte-14upwad-rotate}@keyframes svelte-14upwad-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}";
  append(document.head, style);
}

function create_fragment$n(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "circle svelte-14upwad");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function instance$n($$self, $$props, $$invalidate) {
  var _$$props$color = $$props.color,
      color = _$$props$color === void 0 ? "#FF3E00" : _$$props$color;
  var _$$props$unit = $$props.unit,
      unit = _$$props$unit === void 0 ? "px" : _$$props$unit;
  var _$$props$duration = $$props.duration,
      duration = _$$props$duration === void 0 ? "0.75s" : _$$props$duration;
  var _$$props$size = $$props.size,
      size = _$$props$size === void 0 ? "60" : _$$props$size;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var Circle = /*#__PURE__*/function (_SvelteComponent) {
  _inherits(Circle, _SvelteComponent);

  var _super = _createSuper(Circle);

  function Circle(options) {
    var _this;

    _classCallCheck(this, Circle);

    _this = _super.call(this);
    if (!document.getElementById("svelte-14upwad-style")) add_css$n();
    init(_assertThisInitialized(_this), options, instance$n, create_fragment$n, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this;
  }

  return _createClass(Circle);
}(SvelteComponent);
/* src\Circle2.svelte generated by Svelte v3.38.3 */


function add_css$m() {
  var style = element("style");
  style.id = "svelte-1vclic6-style";
  style.textContent = ".circle.svelte-1vclic6{width:var(--size);height:var(--size);box-sizing:border-box;position:relative;border:3px solid transparent;border-top-color:var(--colorOuter);border-radius:50%;animation:svelte-1vclic6-circleSpin var(--durationOuter) linear infinite}.circle.svelte-1vclic6:before,.circle.svelte-1vclic6:after{content:\"\";box-sizing:border-box;position:absolute;border:3px solid transparent;border-radius:50%}.circle.svelte-1vclic6:after{border-top-color:var(--colorInner);top:9px;left:9px;right:9px;bottom:9px;animation:svelte-1vclic6-circleSpin var(--durationInner) linear infinite}.circle.svelte-1vclic6:before{border-top-color:var(--colorCenter);top:3px;left:3px;right:3px;bottom:3px;animation:svelte-1vclic6-circleSpin var(--durationCenter) linear infinite}@keyframes svelte-1vclic6-circleSpin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}";
  append(document.head, style);
}

function create_fragment$m(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "circle svelte-1vclic6");
      set_style(div, "--size",
      /*size*/
      ctx[0] +
      /*unit*/
      ctx[1]);
      set_style(div, "--colorInner",
      /*colorInner*/
      ctx[4]);
      set_style(div, "--colorCenter",
      /*colorCenter*/
      ctx[3]);
      set_style(div, "--colorOuter",
      /*colorOuter*/
      ctx[2]);
      set_style(div, "--durationInner",
      /*durationInner*/
      ctx[6]);
      set_style(div, "--durationCenter",
      /*durationCenter*/
      ctx[7]);
      set_style(div, "--durationOuter",
      /*durationOuter*/
      ctx[5]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          dirty = _ref4[0];

      if (dirty &
      /*size, unit*/
      3) {
        set_style(div, "--size",
        /*size*/
        ctx[0] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*colorInner*/
      16) {
        set_style(div, "--colorInner",
        /*colorInner*/
        ctx[4]);
      }

      if (dirty &
      /*colorCenter*/
      8) {
        set_style(div, "--colorCenter",
        /*colorCenter*/
        ctx[3]);
      }

      if (dirty &
      /*colorOuter*/
      4) {
        set_style(div, "--colorOuter",
        /*colorOuter*/
        ctx[2]);
      }

      if (dirty &
      /*durationInner*/
      64) {
        set_style(div, "--durationInner",
        /*durationInner*/
        ctx[6]);
      }

      if (dirty &
      /*durationCenter*/
      128) {
        set_style(div, "--durationCenter",
        /*durationCenter*/
        ctx[7]);
      }

      if (dirty &
      /*durationOuter*/
      32) {
        set_style(div, "--durationOuter",
        /*durationOuter*/
        ctx[5]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function instance$m($$self, $$props, $$invalidate) {
  var _$$props$size2 = $$props.size,
      size = _$$props$size2 === void 0 ? "60" : _$$props$size2;
  var _$$props$unit2 = $$props.unit,
      unit = _$$props$unit2 === void 0 ? "px" : _$$props$unit2;
  var _$$props$colorOuter = $$props.colorOuter,
      colorOuter = _$$props$colorOuter === void 0 ? "#FF3E00" : _$$props$colorOuter;
  var _$$props$colorCenter = $$props.colorCenter,
      colorCenter = _$$props$colorCenter === void 0 ? "#40B3FF" : _$$props$colorCenter;
  var _$$props$colorInner = $$props.colorInner,
      colorInner = _$$props$colorInner === void 0 ? "#676778" : _$$props$colorInner;
  var _$$props$durationMult = $$props.durationMultiplier,
      durationMultiplier = _$$props$durationMult === void 0 ? 1 : _$$props$durationMult;
  var _$$props$durationOute = $$props.durationOuter,
      durationOuter = _$$props$durationOute === void 0 ? "".concat(durationMultiplier * 2, "s") : _$$props$durationOute;
  var _$$props$durationInne = $$props.durationInner,
      durationInner = _$$props$durationInne === void 0 ? "".concat(durationMultiplier * 1.5, "s") : _$$props$durationInne;
  var _$$props$durationCent = $$props.durationCenter,
      durationCenter = _$$props$durationCent === void 0 ? "".concat(durationMultiplier * 3, "s") : _$$props$durationCent;

  $$self.$$set = function ($$props) {
    if ("size" in $$props) $$invalidate(0, size = $$props.size);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("colorOuter" in $$props) $$invalidate(2, colorOuter = $$props.colorOuter);
    if ("colorCenter" in $$props) $$invalidate(3, colorCenter = $$props.colorCenter);
    if ("colorInner" in $$props) $$invalidate(4, colorInner = $$props.colorInner);
    if ("durationMultiplier" in $$props) $$invalidate(8, durationMultiplier = $$props.durationMultiplier);
    if ("durationOuter" in $$props) $$invalidate(5, durationOuter = $$props.durationOuter);
    if ("durationInner" in $$props) $$invalidate(6, durationInner = $$props.durationInner);
    if ("durationCenter" in $$props) $$invalidate(7, durationCenter = $$props.durationCenter);
  };

  return [size, unit, colorOuter, colorCenter, colorInner, durationOuter, durationInner, durationCenter, durationMultiplier];
}

var Circle2 = /*#__PURE__*/function (_SvelteComponent2) {
  _inherits(Circle2, _SvelteComponent2);

  var _super2 = _createSuper(Circle2);

  function Circle2(options) {
    var _this2;

    _classCallCheck(this, Circle2);

    _this2 = _super2.call(this);
    if (!document.getElementById("svelte-1vclic6-style")) add_css$m();
    init(_assertThisInitialized(_this2), options, instance$m, create_fragment$m, safe_not_equal, {
      size: 0,
      unit: 1,
      colorOuter: 2,
      colorCenter: 3,
      colorInner: 4,
      durationMultiplier: 8,
      durationOuter: 5,
      durationInner: 6,
      durationCenter: 7
    });
    return _this2;
  }

  return _createClass(Circle2);
}(SvelteComponent);
/* src\Circle3.svelte generated by Svelte v3.38.3 */


function add_css$l() {
  var style = element("style");
  style.id = "svelte-1vf8im1-style";
  style.textContent = ".wrapper.svelte-1vf8im1{width:var(--size);height:var(--size);display:flex;justify-content:center;align-items:center;line-height:0;box-sizing:border-box}.inner.svelte-1vf8im1{transform:scale(calc(var(--floatSize) / 52))}.ball-container.svelte-1vf8im1{animation:svelte-1vf8im1-ballTwo var(--duration) infinite;width:44px;height:44px;flex-shrink:0;position:relative}.single-ball.svelte-1vf8im1{width:44px;height:44px;position:absolute}.ball.svelte-1vf8im1{width:20px;height:20px;border-radius:50%;position:absolute;animation:svelte-1vf8im1-ballOne var(--duration) infinite ease}.ball-top-left.svelte-1vf8im1{background-color:var(--ballTopLeftColor);top:0;left:0}.ball-top-right.svelte-1vf8im1{background-color:var(--ballTopRightColor);top:0;left:24px}.ball-bottom-left.svelte-1vf8im1{background-color:var(--ballBottomLeftColor);top:24px;left:0}.ball-bottom-right.svelte-1vf8im1{background-color:var(--ballBottomRightColor);top:24px;left:24px}@keyframes svelte-1vf8im1-ballOne{0%{position:absolute}50%{top:12px;left:12px;position:absolute;opacity:0.5}100%{position:absolute}}@keyframes svelte-1vf8im1-ballTwo{0%{transform:rotate(0deg) scale(1)}50%{transform:rotate(360deg) scale(1.3)}100%{transform:rotate(720deg) scale(1)}}";
  append(document.head, style);
}

function create_fragment$l(ctx) {
  var div10;
  var div9;
  return {
    c: function c() {
      div10 = element("div");
      div9 = element("div");
      div9.innerHTML = "<div class=\"ball-container svelte-1vf8im1\"><div class=\"single-ball svelte-1vf8im1\"><div class=\"ball ball-top-left svelte-1vf8im1\">\xA0</div></div> \n      <div class=\"contener_mixte\"><div class=\"ball ball-top-right svelte-1vf8im1\">\xA0</div></div> \n      <div class=\"contener_mixte\"><div class=\"ball ball-bottom-left svelte-1vf8im1\">\xA0</div></div> \n      <div class=\"contener_mixte\"><div class=\"ball ball-bottom-right svelte-1vf8im1\">\xA0</div></div></div>";
      attr(div9, "class", "inner svelte-1vf8im1");
      attr(div10, "class", "wrapper svelte-1vf8im1");
      set_style(div10, "--size",
      /*size*/
      ctx[0] +
      /*unit*/
      ctx[1]);
      set_style(div10, "--floatSize",
      /*size*/
      ctx[0]);
      set_style(div10, "--ballTopLeftColor",
      /*ballTopLeft*/
      ctx[2]);
      set_style(div10, "--ballTopRightColor",
      /*ballTopRight*/
      ctx[3]);
      set_style(div10, "--ballBottomLeftColor",
      /*ballBottomLeft*/
      ctx[4]);
      set_style(div10, "--ballBottomRightColor",
      /*ballBottomRight*/
      ctx[5]);
      set_style(div10, "--duration",
      /*duration*/
      ctx[6]);
    },
    m: function m(target, anchor) {
      insert(target, div10, anchor);
      append(div10, div9);
    },
    p: function p(ctx, _ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
          dirty = _ref6[0];

      if (dirty &
      /*size, unit*/
      3) {
        set_style(div10, "--size",
        /*size*/
        ctx[0] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*size*/
      1) {
        set_style(div10, "--floatSize",
        /*size*/
        ctx[0]);
      }

      if (dirty &
      /*ballTopLeft*/
      4) {
        set_style(div10, "--ballTopLeftColor",
        /*ballTopLeft*/
        ctx[2]);
      }

      if (dirty &
      /*ballTopRight*/
      8) {
        set_style(div10, "--ballTopRightColor",
        /*ballTopRight*/
        ctx[3]);
      }

      if (dirty &
      /*ballBottomLeft*/
      16) {
        set_style(div10, "--ballBottomLeftColor",
        /*ballBottomLeft*/
        ctx[4]);
      }

      if (dirty &
      /*ballBottomRight*/
      32) {
        set_style(div10, "--ballBottomRightColor",
        /*ballBottomRight*/
        ctx[5]);
      }

      if (dirty &
      /*duration*/
      64) {
        set_style(div10, "--duration",
        /*duration*/
        ctx[6]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div10);
    }
  };
}

function instance$l($$self, $$props, $$invalidate) {
  var _$$props$size3 = $$props.size,
      size = _$$props$size3 === void 0 ? "60" : _$$props$size3;
  var _$$props$unit3 = $$props.unit,
      unit = _$$props$unit3 === void 0 ? "px" : _$$props$unit3;
  var _$$props$ballTopLeft = $$props.ballTopLeft,
      ballTopLeft = _$$props$ballTopLeft === void 0 ? "#FF3E00" : _$$props$ballTopLeft;
  var _$$props$ballTopRight = $$props.ballTopRight,
      ballTopRight = _$$props$ballTopRight === void 0 ? "#F8B334" : _$$props$ballTopRight;
  var _$$props$ballBottomLe = $$props.ballBottomLeft,
      ballBottomLeft = _$$props$ballBottomLe === void 0 ? "#40B3FF" : _$$props$ballBottomLe;
  var _$$props$ballBottomRi = $$props.ballBottomRight,
      ballBottomRight = _$$props$ballBottomRi === void 0 ? "#676778" : _$$props$ballBottomRi;
  var _$$props$duration2 = $$props.duration,
      duration = _$$props$duration2 === void 0 ? "1.5s" : _$$props$duration2;

  $$self.$$set = function ($$props) {
    if ("size" in $$props) $$invalidate(0, size = $$props.size);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("ballTopLeft" in $$props) $$invalidate(2, ballTopLeft = $$props.ballTopLeft);
    if ("ballTopRight" in $$props) $$invalidate(3, ballTopRight = $$props.ballTopRight);
    if ("ballBottomLeft" in $$props) $$invalidate(4, ballBottomLeft = $$props.ballBottomLeft);
    if ("ballBottomRight" in $$props) $$invalidate(5, ballBottomRight = $$props.ballBottomRight);
    if ("duration" in $$props) $$invalidate(6, duration = $$props.duration);
  };

  return [size, unit, ballTopLeft, ballTopRight, ballBottomLeft, ballBottomRight, duration];
}

var Circle3 = /*#__PURE__*/function (_SvelteComponent3) {
  _inherits(Circle3, _SvelteComponent3);

  var _super3 = _createSuper(Circle3);

  function Circle3(options) {
    var _this3;

    _classCallCheck(this, Circle3);

    _this3 = _super3.call(this);
    if (!document.getElementById("svelte-1vf8im1-style")) add_css$l();
    init(_assertThisInitialized(_this3), options, instance$l, create_fragment$l, safe_not_equal, {
      size: 0,
      unit: 1,
      ballTopLeft: 2,
      ballTopRight: 3,
      ballBottomLeft: 4,
      ballBottomRight: 5,
      duration: 6
    });
    return _this3;
  }

  return _createClass(Circle3);
}(SvelteComponent);

var durationUnitRegex = /[a-zA-Z]/;

var calculateRgba = function calculateRgba(color, opacity) {
  if (color[0] === "#") {
    color = color.slice(1);
  }

  if (color.length === 3) {
    var res = "";
    color.split("").forEach(function (c) {
      res += c;
      res += c;
    });
    color = res;
  }

  var rgbValues = (color.match(/.{2}/g) || []).map(function (hex) {
    return parseInt(hex, 16);
  }).join(", ");
  return "rgba(".concat(rgbValues, ", ").concat(opacity, ")");
};

var range = function range(size) {
  var startAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return _toConsumableArray(Array(size).keys()).map(function (i) {
    return i + startAt;
  });
}; // export const characterRange = (startChar, endChar) =>
//   String.fromCharCode(
//     ...range(
//       endChar.charCodeAt(0) - startChar.charCodeAt(0),
//       startChar.charCodeAt(0)
//     )
//   );
// export const zip = (arr, ...arrs) =>
//   arr.map((val, i) => arrs.reduce((list, curr) => [...list, curr[i]], [val]));

/* src\DoubleBounce.svelte generated by Svelte v3.38.3 */


function add_css$k() {
  var style = element("style");
  style.id = "svelte-h1a2xs-style";
  style.textContent = ".wrapper.svelte-h1a2xs{position:relative;width:var(--size);height:var(--size)}.circle.svelte-h1a2xs{position:absolute;width:var(--size);height:var(--size);background-color:var(--color);border-radius:100%;opacity:0.6;top:0;left:0;animation-fill-mode:both;animation-name:svelte-h1a2xs-bounce !important}@keyframes svelte-h1a2xs-bounce{0%,100%{transform:scale(0)}50%{transform:scale(1)}}";
  append(document.head, style);
}

function get_each_context$9(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (41:2) {#each range(2, 1) as version}


function create_each_block$9(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "circle svelte-h1a2xs");
      set_style(div, "animation",
      /*duration*/
      ctx[2] + " " + (
      /*version*/
      ctx[6] === 1 ? "".concat((
      /*durationNum*/
      ctx[5] - 0.1) / 2).concat(
      /*durationUnit*/
      ctx[4]) : "0s") + " infinite ease-in-out");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*duration*/
      4) {
        set_style(div, "animation",
        /*duration*/
        ctx[2] + " " + (
        /*version*/
        ctx[6] === 1 ? "".concat((
        /*durationNum*/
        ctx[5] - 0.1) / 2).concat(
        /*durationUnit*/
        ctx[4]) : "0s") + " infinite ease-in-out");
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$k(ctx) {
  var div;
  var each_value = range(2, 1);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$9(get_each_context$9(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i3 = 0; _i3 < each_blocks.length; _i3 += 1) {
        each_blocks[_i3].c();
      }

      attr(div, "class", "wrapper svelte-h1a2xs");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i4 = 0; _i4 < each_blocks.length; _i4 += 1) {
        each_blocks[_i4].m(div, null);
      }
    },
    p: function p(ctx, _ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
          dirty = _ref8[0];

      if (dirty &
      /*duration, range, durationNum, durationUnit*/
      52) {
        each_value = range(2, 1);

        var _i5;

        for (_i5 = 0; _i5 < each_value.length; _i5 += 1) {
          var child_ctx = get_each_context$9(ctx, each_value, _i5);

          if (each_blocks[_i5]) {
            each_blocks[_i5].p(child_ctx, dirty);
          } else {
            each_blocks[_i5] = create_each_block$9(child_ctx);

            each_blocks[_i5].c();

            each_blocks[_i5].m(div, null);
          }
        }

        for (; _i5 < each_blocks.length; _i5 += 1) {
          each_blocks[_i5].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$k($$self, $$props, $$invalidate) {
  var _$$props$color2 = $$props.color,
      color = _$$props$color2 === void 0 ? "#FF3E00" : _$$props$color2;
  var _$$props$unit4 = $$props.unit,
      unit = _$$props$unit4 === void 0 ? "px" : _$$props$unit4;
  var _$$props$duration3 = $$props.duration,
      duration = _$$props$duration3 === void 0 ? "2.1s" : _$$props$duration3;
  var _$$props$size4 = $$props.size,
      size = _$$props$size4 === void 0 ? "60" : _$$props$size4;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var DoubleBounce = /*#__PURE__*/function (_SvelteComponent4) {
  _inherits(DoubleBounce, _SvelteComponent4);

  var _super4 = _createSuper(DoubleBounce);

  function DoubleBounce(options) {
    var _this4;

    _classCallCheck(this, DoubleBounce);

    _this4 = _super4.call(this);
    if (!document.getElementById("svelte-h1a2xs-style")) add_css$k();
    init(_assertThisInitialized(_this4), options, instance$k, create_fragment$k, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this4;
  }

  return _createClass(DoubleBounce);
}(SvelteComponent);
/* src\GoogleSpin.svelte generated by Svelte v3.38.3 */


function add_css$j() {
  var style = element("style");
  style.id = "svelte-1exboqr-style";
  style.textContent = ".svelte-1exboqr{overflow:hidden;position:relative;text-indent:-9999px;display:inline-block;background:#f86;border-radius:50%;transform:rotateZ(90deg);transform-origin:50% 50%;animation:svelte-1exboqr-plus-loader-background var(--duration) infinite ease-in-out}.svelte-1exboqr:after{background:#f86;border-radius:50% 0 0 50%;content:\"\";position:absolute;right:50%;top:0;width:50%;height:100%;transform-origin:100% 50%;animation:svelte-1exboqr-plus-loader-top var(--duration) infinite linear}.svelte-1exboqr:before{background:#fc6;border-radius:50% 0 0 50%;content:\"\";position:absolute;right:50%;top:0;width:50%;height:100%;transform-origin:100% 50%;animation:svelte-1exboqr-plus-loader-bottom var(--duration) infinite linear}@keyframes svelte-1exboqr-plus-loader-top{2.5%{background:#f86;transform:rotateY(0deg);animation-timing-function:ease-in}13.75%{background:#ff430d;transform:rotateY(90deg);animation-timing-function:step-start}13.76%{background:#ffae0d;transform:rotateY(90deg);animation-timing-function:ease-out}25%{background:#fc6;transform:rotateY(180deg)}27.5%{background:#fc6;transform:rotateY(180deg);animation-timing-function:ease-in}41.25%{background:#ffae0d;transform:rotateY(90deg);animation-timing-function:step-start}41.26%{background:#2cc642;transform:rotateY(90deg);animation-timing-function:ease-out}50%{background:#6d7;transform:rotateY(0deg)}52.5%{background:#6d7;transform:rotateY(0deg);animation-timing-function:ease-in}63.75%{background:#2cc642;transform:rotateY(90deg);animation-timing-function:step-start}63.76%{background:#1386d2;transform:rotateY(90deg);animation-timing-function:ease-out}75%{background:#4ae;transform:rotateY(180deg)}77.5%{background:#4ae;transform:rotateY(180deg);animation-timing-function:ease-in}91.25%{background:#1386d2;transform:rotateY(90deg);animation-timing-function:step-start}91.26%{background:#ff430d;transform:rotateY(90deg);animation-timing-function:ease-in}100%{background:#f86;transform:rotateY(0deg);animation-timing-function:step-start}}@keyframes svelte-1exboqr-plus-loader-bottom{0%{background:#fc6;animation-timing-function:step-start}50%{background:#fc6;animation-timing-function:step-start}75%{background:#4ae;animation-timing-function:step-start}100%{background:#4ae;animation-timing-function:step-start}}@keyframes svelte-1exboqr-plus-loader-background{0%{background:#f86;transform:rotateZ(180deg)}25%{background:#f86;transform:rotateZ(180deg);animation-timing-function:step-start}27.5%{background:#6d7;transform:rotateZ(90deg)}50%{background:#6d7;transform:rotateZ(90deg);animation-timing-function:step-start}52.5%{background:#6d7;transform:rotateZ(0deg)}75%{background:#6d7;transform:rotateZ(0deg);animation-timing-function:step-start}77.5%{background:#f86;transform:rotateZ(270deg)}100%{background:#f86;transform:rotateZ(270deg);animation-timing-function:step-start}}";
  append(document.head, style);
}

function create_fragment$j(ctx) {
  var div;
  var div_style_value;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "spinner spinner--google svelte-1exboqr");
      attr(div, "style", div_style_value = "--duration: " +
      /*duration*/
      ctx[0] + "; " +
      /*styles*/
      ctx[1]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, _ref9) {
      var _ref10 = _slicedToArray(_ref9, 1),
          dirty = _ref10[0];

      if (dirty &
      /*duration, styles*/
      3 && div_style_value !== (div_style_value = "--duration: " +
      /*duration*/
      ctx[0] + "; " +
      /*styles*/
      ctx[1])) {
        attr(div, "style", div_style_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function instance$j($$self, $$props, $$invalidate) {
  var styles;
  var _$$props$size5 = $$props.size,
      size = _$$props$size5 === void 0 ? "40px" : _$$props$size5;
  var _$$props$duration4 = $$props.duration,
      duration = _$$props$duration4 === void 0 ? "3s" : _$$props$duration4;

  $$self.$$set = function ($$props) {
    if ("size" in $$props) $$invalidate(2, size = $$props.size);
    if ("duration" in $$props) $$invalidate(0, duration = $$props.duration);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*size*/
    4) {
      $$invalidate(1, styles = ["width: ".concat(size), "height: ".concat(size)].join(";"));
    }
  };

  return [duration, styles, size];
}

var GoogleSpin = /*#__PURE__*/function (_SvelteComponent5) {
  _inherits(GoogleSpin, _SvelteComponent5);

  var _super5 = _createSuper(GoogleSpin);

  function GoogleSpin(options) {
    var _this5;

    _classCallCheck(this, GoogleSpin);

    _this5 = _super5.call(this);
    if (!document.getElementById("svelte-1exboqr-style")) add_css$j();
    init(_assertThisInitialized(_this5), options, instance$j, create_fragment$j, safe_not_equal, {
      size: 2,
      duration: 0
    });
    return _this5;
  }

  return _createClass(GoogleSpin);
}(SvelteComponent);
/* src\ScaleOut.svelte generated by Svelte v3.38.3 */


function add_css$i() {
  var style = element("style");
  style.id = "svelte-9juun5-style";
  style.textContent = ".wrapper.svelte-9juun5{width:var(--size);height:var(--size)}.circle.svelte-9juun5{width:var(--size);height:var(--size);background-color:var(--color);animation-duration:var(--duration);border-radius:100%;display:inline-block;animation:svelte-9juun5-scaleOut var(--duration) ease-in-out infinite}@keyframes svelte-9juun5-scaleOut{0%{transform:scale(0)}100%{transform:scale(1);opacity:0}}";
  append(document.head, style);
}

function create_fragment$i(ctx) {
  var div1;
  var div0;
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      attr(div0, "class", "circle svelte-9juun5");
      attr(div1, "class", "wrapper svelte-9juun5");
      set_style(div1, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div1, "--color",
      /*color*/
      ctx[0]);
      set_style(div1, "--duration",
      /*duration*/
      ctx[2]);
      set_style(div1, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
    },
    p: function p(ctx, _ref11) {
      var _ref12 = _slicedToArray(_ref11, 1),
          dirty = _ref12[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div1, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div1, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div1, "--duration",
        /*duration*/
        ctx[2]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div1, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div1);
    }
  };
}

function instance$i($$self, $$props, $$invalidate) {
  var _$$props$color3 = $$props.color,
      color = _$$props$color3 === void 0 ? "#FF3E00" : _$$props$color3;
  var _$$props$unit5 = $$props.unit,
      unit = _$$props$unit5 === void 0 ? "px" : _$$props$unit5;
  var _$$props$duration5 = $$props.duration,
      duration = _$$props$duration5 === void 0 ? "1s" : _$$props$duration5;
  var _$$props$size6 = $$props.size,
      size = _$$props$size6 === void 0 ? "60" : _$$props$size6;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var ScaleOut = /*#__PURE__*/function (_SvelteComponent6) {
  _inherits(ScaleOut, _SvelteComponent6);

  var _super6 = _createSuper(ScaleOut);

  function ScaleOut(options) {
    var _this6;

    _classCallCheck(this, ScaleOut);

    _this6 = _super6.call(this);
    if (!document.getElementById("svelte-9juun5-style")) add_css$i();
    init(_assertThisInitialized(_this6), options, instance$i, create_fragment$i, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this6;
  }

  return _createClass(ScaleOut);
}(SvelteComponent);
/* src\SpinLine.svelte generated by Svelte v3.38.3 */


function add_css$h() {
  var style = element("style");
  style.id = "svelte-1wp57lu-style";
  style.textContent = ".wrapper.svelte-1wp57lu{width:var(--size);height:var(--stroke);transform:scale(calc(var(--floatSize) / 75));display:flex;justify-content:center;align-items:center}.line.svelte-1wp57lu{width:var(--size);height:var(--stroke);background:var(--color);border-radius:var(--stroke);transform-origin:center center;animation:svelte-1wp57lu-spineLine var(--duration) ease infinite}@keyframes svelte-1wp57lu-spineLine{0%{transform:rotate(-20deg);height:5px;width:75px}5%{height:5px;width:75px}30%{transform:rotate(380deg);height:5px;width:75px}40%{transform:rotate(360deg);height:5px;width:75px}55%{transform:rotate(0deg);height:5px;width:5px}65%{transform:rotate(0deg);height:5px;width:85px}68%{transform:rotate(0deg);height:5px}75%{transform:rotate(0deg);height:5px;width:1px}78%{height:5px;width:5px}90%{height:5px;width:75px;transform:rotate(0deg)}99%,100%{height:5px;width:75px;transform:rotate(-20deg)}}";
  append(document.head, style);
}

function create_fragment$h(ctx) {
  var div1;
  var div0;
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      attr(div0, "class", "line svelte-1wp57lu");
      attr(div1, "class", "wrapper svelte-1wp57lu");
      set_style(div1, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div1, "--color",
      /*color*/
      ctx[0]);
      set_style(div1, "--stroke",
      /*stroke*/
      ctx[4]);
      set_style(div1, "--floatSize",
      /*size*/
      ctx[3]);
      set_style(div1, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
    },
    p: function p(ctx, _ref13) {
      var _ref14 = _slicedToArray(_ref13, 1),
          dirty = _ref14[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div1, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div1, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*stroke*/
      16) {
        set_style(div1, "--stroke",
        /*stroke*/
        ctx[4]);
      }

      if (dirty &
      /*size*/
      8) {
        set_style(div1, "--floatSize",
        /*size*/
        ctx[3]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div1, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div1);
    }
  };
}

function instance$h($$self, $$props, $$invalidate) {
  var _$$props$color4 = $$props.color,
      color = _$$props$color4 === void 0 ? "#FF3E00" : _$$props$color4;
  var _$$props$unit6 = $$props.unit,
      unit = _$$props$unit6 === void 0 ? "px" : _$$props$unit6;
  var _$$props$duration6 = $$props.duration,
      duration = _$$props$duration6 === void 0 ? "4s" : _$$props$duration6;
  var _$$props$size7 = $$props.size,
      size = _$$props$size7 === void 0 ? "60" : _$$props$size7;
  var _$$props$stroke = $$props.stroke,
      stroke = _$$props$stroke === void 0 ? +size / 12 + unit : _$$props$stroke;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
    if ("stroke" in $$props) $$invalidate(4, stroke = $$props.stroke);
  };

  return [color, unit, duration, size, stroke];
}

var SpinLine = /*#__PURE__*/function (_SvelteComponent7) {
  _inherits(SpinLine, _SvelteComponent7);

  var _super7 = _createSuper(SpinLine);

  function SpinLine(options) {
    var _this7;

    _classCallCheck(this, SpinLine);

    _this7 = _super7.call(this);
    if (!document.getElementById("svelte-1wp57lu-style")) add_css$h();
    init(_assertThisInitialized(_this7), options, instance$h, create_fragment$h, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3,
      stroke: 4
    });
    return _this7;
  }

  return _createClass(SpinLine);
}(SvelteComponent);
/* src\Stretch.svelte generated by Svelte v3.38.3 */


function add_css$g() {
  var style = element("style");
  style.id = "svelte-1uxpkwt-style";
  style.textContent = ".wrapper.svelte-1uxpkwt{height:var(--size);width:var(--size);display:inline-block;text-align:center;font-size:10px}.rect.svelte-1uxpkwt{height:100%;width:10%;display:inline-block;margin-right:4px;background-color:var(--color);animation:svelte-1uxpkwt-stretch var(--duration) ease-in-out infinite}@keyframes svelte-1uxpkwt-stretch{0%,40%,100%{transform:scaleY(0.4)}20%{transform:scaleY(1)}}";
  append(document.head, style);
}

function get_each_context$8(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (42:2) {#each range(5, 1) as version}


function create_each_block$8(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "rect svelte-1uxpkwt");
      set_style(div, "animation-delay", (
      /*version*/
      ctx[6] - 1) * (+
      /*durationNum*/
      ctx[5] / 12) +
      /*durationUnit*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$g(ctx) {
  var div;
  var each_value = range(5, 1);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$8(get_each_context$8(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i6 = 0; _i6 < each_blocks.length; _i6 += 1) {
        each_blocks[_i6].c();
      }

      attr(div, "class", "wrapper svelte-1uxpkwt");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i7 = 0; _i7 < each_blocks.length; _i7 += 1) {
        each_blocks[_i7].m(div, null);
      }
    },
    p: function p(ctx, _ref15) {
      var _ref16 = _slicedToArray(_ref15, 1),
          dirty = _ref16[0];

      if (dirty &
      /*range, durationNum, durationUnit*/
      48) {
        each_value = range(5, 1);

        var _i8;

        for (_i8 = 0; _i8 < each_value.length; _i8 += 1) {
          var child_ctx = get_each_context$8(ctx, each_value, _i8);

          if (each_blocks[_i8]) {
            each_blocks[_i8].p(child_ctx, dirty);
          } else {
            each_blocks[_i8] = create_each_block$8(child_ctx);

            each_blocks[_i8].c();

            each_blocks[_i8].m(div, null);
          }
        }

        for (; _i8 < each_blocks.length; _i8 += 1) {
          each_blocks[_i8].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$g($$self, $$props, $$invalidate) {
  var _$$props$color5 = $$props.color,
      color = _$$props$color5 === void 0 ? "#FF3E00" : _$$props$color5;
  var _$$props$unit7 = $$props.unit,
      unit = _$$props$unit7 === void 0 ? "px" : _$$props$unit7;
  var _$$props$duration7 = $$props.duration,
      duration = _$$props$duration7 === void 0 ? "1.2s" : _$$props$duration7;
  var _$$props$size8 = $$props.size,
      size = _$$props$size8 === void 0 ? "60" : _$$props$size8;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var Stretch = /*#__PURE__*/function (_SvelteComponent8) {
  _inherits(Stretch, _SvelteComponent8);

  var _super8 = _createSuper(Stretch);

  function Stretch(options) {
    var _this8;

    _classCallCheck(this, Stretch);

    _this8 = _super8.call(this);
    if (!document.getElementById("svelte-1uxpkwt-style")) add_css$g();
    init(_assertThisInitialized(_this8), options, instance$g, create_fragment$g, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this8;
  }

  return _createClass(Stretch);
}(SvelteComponent);
/* src\BarLoader.svelte generated by Svelte v3.38.3 */


function add_css$f() {
  var style = element("style");
  style.id = "svelte-vhcw6-style";
  style.textContent = ".wrapper.svelte-vhcw6{height:calc(var(--size) / 15);width:calc(var(--size) * 2);background-color:var(--rgba);position:relative;overflow:hidden;background-clip:padding-box}.lines.svelte-vhcw6{height:calc(var(--size) / 15);background-color:var(--color)}.small-lines.svelte-vhcw6{position:absolute;overflow:hidden;background-clip:padding-box;display:block;border-radius:2px;will-change:left, right;animation-fill-mode:forwards}.small-lines.\\31 .svelte-vhcw6{animation:var(--duration) cubic-bezier(0.65, 0.815, 0.735, 0.395) 0s\r\n      infinite normal none running svelte-vhcw6-long}.small-lines.\\32 .svelte-vhcw6{animation:var(--duration) cubic-bezier(0.165, 0.84, 0.44, 1)\r\n      calc((var(--duration)+0.1) / 2) infinite normal none running svelte-vhcw6-short}@keyframes svelte-vhcw6-long{0%{left:-35%;right:100%}60%{left:100%;right:-90%}100%{left:100%;right:-90%}}@keyframes svelte-vhcw6-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}100%{left:107%;right:-8%}}";
  append(document.head, style);
}

function get_each_context$7(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[5] = list[i];
  return child_ctx;
} // (74:2) {#each range(2, 1) as version}


function create_each_block$7(ctx) {
  var div;
  var div_class_value;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", div_class_value = "lines small-lines " +
      /*version*/
      ctx[5] + " svelte-vhcw6");
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$f(ctx) {
  var div;
  var each_value = range(2, 1);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$7(get_each_context$7(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i9 = 0; _i9 < each_blocks.length; _i9 += 1) {
        each_blocks[_i9].c();
      }

      attr(div, "class", "wrapper svelte-vhcw6");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--rgba",
      /*rgba*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i10 = 0; _i10 < each_blocks.length; _i10 += 1) {
        each_blocks[_i10].m(div, null);
      }
    },
    p: function p(ctx, _ref17) {
      var _ref18 = _slicedToArray(_ref17, 1),
          dirty = _ref18[0];

      if (dirty &
      /*range, color, duration*/
      5) {
        each_value = range(2, 1);

        var _i11;

        for (_i11 = 0; _i11 < each_value.length; _i11 += 1) {
          var child_ctx = get_each_context$7(ctx, each_value, _i11);

          if (each_blocks[_i11]) {
            each_blocks[_i11].p(child_ctx, dirty);
          } else {
            each_blocks[_i11] = create_each_block$7(child_ctx);

            each_blocks[_i11].c();

            each_blocks[_i11].m(div, null);
          }
        }

        for (; _i11 < each_blocks.length; _i11 += 1) {
          each_blocks[_i11].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*rgba*/
      16) {
        set_style(div, "--rgba",
        /*rgba*/
        ctx[4]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$f($$self, $$props, $$invalidate) {
  var _$$props$color6 = $$props.color,
      color = _$$props$color6 === void 0 ? "#FF3E00" : _$$props$color6;
  var _$$props$unit8 = $$props.unit,
      unit = _$$props$unit8 === void 0 ? "px" : _$$props$unit8;
  var _$$props$duration8 = $$props.duration,
      duration = _$$props$duration8 === void 0 ? "2.1s" : _$$props$duration8;
  var _$$props$size9 = $$props.size,
      size = _$$props$size9 === void 0 ? "60" : _$$props$size9;
  var rgba;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*color*/
    1) {
      $$invalidate(4, rgba = calculateRgba(color, 0.2));
    }
  };

  return [color, unit, duration, size, rgba];
}

var BarLoader = /*#__PURE__*/function (_SvelteComponent9) {
  _inherits(BarLoader, _SvelteComponent9);

  var _super9 = _createSuper(BarLoader);

  function BarLoader(options) {
    var _this9;

    _classCallCheck(this, BarLoader);

    _this9 = _super9.call(this);
    if (!document.getElementById("svelte-vhcw6-style")) add_css$f();
    init(_assertThisInitialized(_this9), options, instance$f, create_fragment$f, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this9;
  }

  return _createClass(BarLoader);
}(SvelteComponent);
/* src\Jumper.svelte generated by Svelte v3.38.3 */


function add_css$e() {
  var style = element("style");
  style.id = "svelte-1cy66mt-style";
  style.textContent = ".wrapper.svelte-1cy66mt{width:var(--size);height:var(--size)}.circle.svelte-1cy66mt{border-radius:100%;animation-fill-mode:both;position:absolute;opacity:0;width:var(--size);height:var(--size);background-color:var(--color);animation:svelte-1cy66mt-bounce var(--duration) linear infinite}@keyframes svelte-1cy66mt-bounce{0%{opacity:0;transform:scale(0)}5%{opacity:1}100%{opacity:0;transform:scale(1)}}";
  append(document.head, style);
}

function get_each_context$6(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (44:2) {#each range(3, 1) as version}


function create_each_block$6(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "circle svelte-1cy66mt");
      set_style(div, "animation-delay",
      /*durationNum*/
      ctx[5] / 3 * (
      /*version*/
      ctx[6] - 1) +
      /*durationUnit*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$e(ctx) {
  var div;
  var each_value = range(3, 1);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$6(get_each_context$6(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i12 = 0; _i12 < each_blocks.length; _i12 += 1) {
        each_blocks[_i12].c();
      }

      attr(div, "class", "wrapper svelte-1cy66mt");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i13 = 0; _i13 < each_blocks.length; _i13 += 1) {
        each_blocks[_i13].m(div, null);
      }
    },
    p: function p(ctx, _ref19) {
      var _ref20 = _slicedToArray(_ref19, 1),
          dirty = _ref20[0];

      if (dirty &
      /*durationNum, range, durationUnit*/
      48) {
        each_value = range(3, 1);

        var _i14;

        for (_i14 = 0; _i14 < each_value.length; _i14 += 1) {
          var child_ctx = get_each_context$6(ctx, each_value, _i14);

          if (each_blocks[_i14]) {
            each_blocks[_i14].p(child_ctx, dirty);
          } else {
            each_blocks[_i14] = create_each_block$6(child_ctx);

            each_blocks[_i14].c();

            each_blocks[_i14].m(div, null);
          }
        }

        for (; _i14 < each_blocks.length; _i14 += 1) {
          each_blocks[_i14].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$e($$self, $$props, $$invalidate) {
  var _$$props$color7 = $$props.color,
      color = _$$props$color7 === void 0 ? "#FF3E00" : _$$props$color7;
  var _$$props$unit9 = $$props.unit,
      unit = _$$props$unit9 === void 0 ? "px" : _$$props$unit9;
  var _$$props$duration9 = $$props.duration,
      duration = _$$props$duration9 === void 0 ? "1s" : _$$props$duration9;
  var _$$props$size10 = $$props.size,
      size = _$$props$size10 === void 0 ? "60" : _$$props$size10;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var Jumper = /*#__PURE__*/function (_SvelteComponent10) {
  _inherits(Jumper, _SvelteComponent10);

  var _super10 = _createSuper(Jumper);

  function Jumper(options) {
    var _this10;

    _classCallCheck(this, Jumper);

    _this10 = _super10.call(this);
    if (!document.getElementById("svelte-1cy66mt-style")) add_css$e();
    init(_assertThisInitialized(_this10), options, instance$e, create_fragment$e, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this10;
  }

  return _createClass(Jumper);
}(SvelteComponent);
/* src\RingLoader.svelte generated by Svelte v3.38.3 */


function add_css$d() {
  var style = element("style");
  style.id = "svelte-17ey38u-style";
  style.textContent = ".wrapper.svelte-17ey38u{position:relative;width:var(--size);height:var(--size)}.border.svelte-17ey38u{border-color:var(--color);position:absolute;top:0px;left:0px;width:var(--size);height:var(--size);opacity:0.4;perspective:800px;border-width:6px;border-style:solid;border-image:initial;border-radius:100%}.border.\\31 .svelte-17ey38u{animation:var(--duration) linear 0s infinite normal none running svelte-17ey38u-ringOne}.border.\\32 .svelte-17ey38u{animation:var(--duration) linear 0s infinite normal none running svelte-17ey38u-ringTwo}@keyframes svelte-17ey38u-ringOne{0%{transform:rotateX(0deg) rotateY(0deg) rotateZ(0deg)}100%{transform:rotateX(360deg) rotateY(180deg) rotateZ(360deg)}}@keyframes svelte-17ey38u-ringTwo{0%{transform:rotateX(0deg) rotateY(0deg) rotateZ(0deg)}100%{transform:rotateX(180deg) rotateY(360deg) rotateZ(360deg)}}";
  append(document.head, style);
}

function get_each_context$5(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[4] = list[i];
  return child_ctx;
} // (57:2) {#each range(2, 1) as version}


function create_each_block$5(ctx) {
  var div;
  var div_class_value;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", div_class_value = "border " +
      /*version*/
      ctx[4] + " svelte-17ey38u");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$d(ctx) {
  var div;
  var each_value = range(2, 1);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$5(get_each_context$5(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i15 = 0; _i15 < each_blocks.length; _i15 += 1) {
        each_blocks[_i15].c();
      }

      attr(div, "class", "wrapper svelte-17ey38u");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i16 = 0; _i16 < each_blocks.length; _i16 += 1) {
        each_blocks[_i16].m(div, null);
      }
    },
    p: function p(ctx, _ref21) {
      var _ref22 = _slicedToArray(_ref21, 1),
          dirty = _ref22[0];

      if (dirty &
      /*range*/
      0) {
        each_value = range(2, 1);

        var _i17;

        for (_i17 = 0; _i17 < each_value.length; _i17 += 1) {
          var child_ctx = get_each_context$5(ctx, each_value, _i17);

          if (each_blocks[_i17]) {
            each_blocks[_i17].p(child_ctx, dirty);
          } else {
            each_blocks[_i17] = create_each_block$5(child_ctx);

            each_blocks[_i17].c();

            each_blocks[_i17].m(div, null);
          }
        }

        for (; _i17 < each_blocks.length; _i17 += 1) {
          each_blocks[_i17].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$d($$self, $$props, $$invalidate) {
  var _$$props$color8 = $$props.color,
      color = _$$props$color8 === void 0 ? "#FF3E00" : _$$props$color8;
  var _$$props$unit10 = $$props.unit,
      unit = _$$props$unit10 === void 0 ? "px" : _$$props$unit10;
  var _$$props$duration10 = $$props.duration,
      duration = _$$props$duration10 === void 0 ? "2s" : _$$props$duration10;
  var _$$props$size11 = $$props.size,
      size = _$$props$size11 === void 0 ? "60" : _$$props$size11;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var RingLoader = /*#__PURE__*/function (_SvelteComponent11) {
  _inherits(RingLoader, _SvelteComponent11);

  var _super11 = _createSuper(RingLoader);

  function RingLoader(options) {
    var _this11;

    _classCallCheck(this, RingLoader);

    _this11 = _super11.call(this);
    if (!document.getElementById("svelte-17ey38u-style")) add_css$d();
    init(_assertThisInitialized(_this11), options, instance$d, create_fragment$d, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this11;
  }

  return _createClass(RingLoader);
}(SvelteComponent);
/* src\SyncLoader.svelte generated by Svelte v3.38.3 */


function add_css$c() {
  var style = element("style");
  style.id = "svelte-14w6xk7-style";
  style.textContent = ".wrapper.svelte-14w6xk7{height:var(--size);width:var(--size);display:flex;align-items:center;justify-content:center}.dot.svelte-14w6xk7{height:var(--dotSize);width:var(--dotSize);background-color:var(--color);margin:2px;display:inline-block;border-radius:100%;animation:svelte-14w6xk7-sync var(--duration) ease-in-out infinite alternate both running}@-webkit-keyframes svelte-14w6xk7-sync{33%{-webkit-transform:translateY(10px);transform:translateY(10px)}66%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}100%{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes svelte-14w6xk7-sync{33%{-webkit-transform:translateY(10px);transform:translateY(10px)}66%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}100%{-webkit-transform:translateY(0);transform:translateY(0)}}";
  append(document.head, style);
}

function get_each_context$4(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (61:2) {#each range(3, 1) as i}


function create_each_block$4(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "dot svelte-14w6xk7");
      set_style(div, "--dotSize", +
      /*size*/
      ctx[3] * 0.25 +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "animation-delay",
      /*i*/
      ctx[6] * (+
      /*durationNum*/
      ctx[5] / 10) +
      /*durationUnit*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--dotSize", +
        /*size*/
        ctx[3] * 0.25 +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$c(ctx) {
  var div;
  var each_value = range(3, 1);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$4(get_each_context$4(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i18 = 0; _i18 < each_blocks.length; _i18 += 1) {
        each_blocks[_i18].c();
      }

      attr(div, "class", "wrapper svelte-14w6xk7");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i19 = 0; _i19 < each_blocks.length; _i19 += 1) {
        each_blocks[_i19].m(div, null);
      }
    },
    p: function p(ctx, _ref23) {
      var _ref24 = _slicedToArray(_ref23, 1),
          dirty = _ref24[0];

      if (dirty &
      /*size, unit, color, range, durationNum, durationUnit*/
      59) {
        each_value = range(3, 1);

        var _i20;

        for (_i20 = 0; _i20 < each_value.length; _i20 += 1) {
          var child_ctx = get_each_context$4(ctx, each_value, _i20);

          if (each_blocks[_i20]) {
            each_blocks[_i20].p(child_ctx, dirty);
          } else {
            each_blocks[_i20] = create_each_block$4(child_ctx);

            each_blocks[_i20].c();

            each_blocks[_i20].m(div, null);
          }
        }

        for (; _i20 < each_blocks.length; _i20 += 1) {
          each_blocks[_i20].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$c($$self, $$props, $$invalidate) {
  var _$$props$color9 = $$props.color,
      color = _$$props$color9 === void 0 ? "#FF3E00" : _$$props$color9;
  var _$$props$unit11 = $$props.unit,
      unit = _$$props$unit11 === void 0 ? "px" : _$$props$unit11;
  var _$$props$duration11 = $$props.duration,
      duration = _$$props$duration11 === void 0 ? "0.6s" : _$$props$duration11;
  var _$$props$size12 = $$props.size,
      size = _$$props$size12 === void 0 ? "60" : _$$props$size12;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var SyncLoader = /*#__PURE__*/function (_SvelteComponent12) {
  _inherits(SyncLoader, _SvelteComponent12);

  var _super12 = _createSuper(SyncLoader);

  function SyncLoader(options) {
    var _this12;

    _classCallCheck(this, SyncLoader);

    _this12 = _super12.call(this);
    if (!document.getElementById("svelte-14w6xk7-style")) add_css$c();
    init(_assertThisInitialized(_this12), options, instance$c, create_fragment$c, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this12;
  }

  return _createClass(SyncLoader);
}(SvelteComponent);
/* src\Rainbow.svelte generated by Svelte v3.38.3 */


function add_css$b() {
  var style = element("style");
  style.id = "svelte-1fuumrt-style";
  style.textContent = ".wrapper.svelte-1fuumrt{width:var(--size);height:calc(var(--size) / 2);overflow:hidden}.rainbow.svelte-1fuumrt{width:var(--size);height:var(--size);border-left-color:transparent;border-bottom-color:transparent;border-top-color:var(--color);border-right-color:var(--color);box-sizing:border-box;transform:rotate(-200deg);border-radius:50%;border-style:solid;animation:var(--duration) ease-in-out 0s infinite normal none running\r\n      svelte-1fuumrt-rotate}@keyframes svelte-1fuumrt-rotate{0%{border-width:10px}25%{border-width:3px}50%{transform:rotate(115deg);border-width:10px}75%{border-width:3px}100%{border-width:10px}}";
  append(document.head, style);
}

function create_fragment$b(ctx) {
  var div1;
  var div0;
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      attr(div0, "class", "rainbow svelte-1fuumrt");
      attr(div1, "class", "wrapper svelte-1fuumrt");
      set_style(div1, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div1, "--color",
      /*color*/
      ctx[0]);
      set_style(div1, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
    },
    p: function p(ctx, _ref25) {
      var _ref26 = _slicedToArray(_ref25, 1),
          dirty = _ref26[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div1, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div1, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div1, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div1);
    }
  };
}

function instance$b($$self, $$props, $$invalidate) {
  var _$$props$color10 = $$props.color,
      color = _$$props$color10 === void 0 ? "#FF3E00" : _$$props$color10;
  var _$$props$unit12 = $$props.unit,
      unit = _$$props$unit12 === void 0 ? "px" : _$$props$unit12;
  var _$$props$duration12 = $$props.duration,
      duration = _$$props$duration12 === void 0 ? "3s" : _$$props$duration12;
  var _$$props$size13 = $$props.size,
      size = _$$props$size13 === void 0 ? "60" : _$$props$size13;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var Rainbow = /*#__PURE__*/function (_SvelteComponent13) {
  _inherits(Rainbow, _SvelteComponent13);

  var _super13 = _createSuper(Rainbow);

  function Rainbow(options) {
    var _this13;

    _classCallCheck(this, Rainbow);

    _this13 = _super13.call(this);
    if (!document.getElementById("svelte-1fuumrt-style")) add_css$b();
    init(_assertThisInitialized(_this13), options, instance$b, create_fragment$b, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this13;
  }

  return _createClass(Rainbow);
}(SvelteComponent);
/* src\Wave.svelte generated by Svelte v3.38.3 */


function add_css$a() {
  var style = element("style");
  style.id = "svelte-8cmcz4-style";
  style.textContent = ".wrapper.svelte-8cmcz4{position:relative;display:flex;justify-content:center;align-items:center;width:calc(var(--size) * 2.5);height:var(--size);overflow:hidden}.bar.svelte-8cmcz4{position:absolute;top:calc(var(--size) / 10);width:calc(var(--size) / 5);height:calc(var(--size) / 10);margin-top:calc(var(--size) - var(--size) / 10);transform:skewY(0deg);background-color:var(--color);animation:svelte-8cmcz4-motion var(--duration) ease-in-out infinite}@keyframes svelte-8cmcz4-motion{25%{transform:skewY(25deg)}50%{height:100%;margin-top:0}75%{transform:skewY(-25deg)}}";
  append(document.head, style);
}

function get_each_context$3(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (48:2) {#each range(10, 0) as version}


function create_each_block$3(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "bar svelte-8cmcz4");
      set_style(div, "left",
      /*version*/
      ctx[6] * (+
      /*size*/
      ctx[3] / 5 + (+
      /*size*/
      ctx[3] / 15 - +
      /*size*/
      ctx[3] / 100)) +
      /*unit*/
      ctx[1]);
      set_style(div, "animation-delay",
      /*version*/
      ctx[6] * (+
      /*durationNum*/
      ctx[5] / 8.3) +
      /*durationUnit*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "left",
        /*version*/
        ctx[6] * (+
        /*size*/
        ctx[3] / 5 + (+
        /*size*/
        ctx[3] / 15 - +
        /*size*/
        ctx[3] / 100)) +
        /*unit*/
        ctx[1]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$a(ctx) {
  var div;
  var each_value = range(10, 0);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$3(get_each_context$3(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i21 = 0; _i21 < each_blocks.length; _i21 += 1) {
        each_blocks[_i21].c();
      }

      attr(div, "class", "wrapper svelte-8cmcz4");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i22 = 0; _i22 < each_blocks.length; _i22 += 1) {
        each_blocks[_i22].m(div, null);
      }
    },
    p: function p(ctx, _ref27) {
      var _ref28 = _slicedToArray(_ref27, 1),
          dirty = _ref28[0];

      if (dirty &
      /*range, size, unit, durationNum, durationUnit*/
      58) {
        each_value = range(10, 0);

        var _i23;

        for (_i23 = 0; _i23 < each_value.length; _i23 += 1) {
          var child_ctx = get_each_context$3(ctx, each_value, _i23);

          if (each_blocks[_i23]) {
            each_blocks[_i23].p(child_ctx, dirty);
          } else {
            each_blocks[_i23] = create_each_block$3(child_ctx);

            each_blocks[_i23].c();

            each_blocks[_i23].m(div, null);
          }
        }

        for (; _i23 < each_blocks.length; _i23 += 1) {
          each_blocks[_i23].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$a($$self, $$props, $$invalidate) {
  var _$$props$color11 = $$props.color,
      color = _$$props$color11 === void 0 ? "#FF3E00" : _$$props$color11;
  var _$$props$unit13 = $$props.unit,
      unit = _$$props$unit13 === void 0 ? "px" : _$$props$unit13;
  var _$$props$duration13 = $$props.duration,
      duration = _$$props$duration13 === void 0 ? "1.25s" : _$$props$duration13;
  var _$$props$size14 = $$props.size,
      size = _$$props$size14 === void 0 ? "60" : _$$props$size14;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var Wave = /*#__PURE__*/function (_SvelteComponent14) {
  _inherits(Wave, _SvelteComponent14);

  var _super14 = _createSuper(Wave);

  function Wave(options) {
    var _this14;

    _classCallCheck(this, Wave);

    _this14 = _super14.call(this);
    if (!document.getElementById("svelte-8cmcz4-style")) add_css$a();
    init(_assertThisInitialized(_this14), options, instance$a, create_fragment$a, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this14;
  }

  return _createClass(Wave);
}(SvelteComponent);
/* src\Firework.svelte generated by Svelte v3.38.3 */


function add_css$9() {
  var style = element("style");
  style.id = "svelte-1x2s7pr-style";
  style.textContent = ".wrapper.svelte-1x2s7pr{width:calc(var(--size) * 1.3);height:calc(var(--size) * 1.3);display:flex;justify-content:center;align-items:center}.firework.svelte-1x2s7pr{border:calc(var(--size) / 10) dotted var(--color);width:var(--size);height:var(--size);border-radius:50%;animation:svelte-1x2s7pr-fire var(--duration) cubic-bezier(0.165, 0.84, 0.44, 1) infinite}@keyframes svelte-1x2s7pr-fire{0%{opacity:1;transform:scale(0.1)}25%{opacity:0.85}100%{transform:scale(1);opacity:0}}";
  append(document.head, style);
}

function create_fragment$9(ctx) {
  var div1;
  var div0;
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      attr(div0, "class", "firework svelte-1x2s7pr");
      attr(div1, "class", "wrapper svelte-1x2s7pr");
      set_style(div1, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div1, "--color",
      /*color*/
      ctx[0]);
      set_style(div1, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
    },
    p: function p(ctx, _ref29) {
      var _ref30 = _slicedToArray(_ref29, 1),
          dirty = _ref30[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div1, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div1, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div1, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div1);
    }
  };
}

function instance$9($$self, $$props, $$invalidate) {
  var _$$props$color12 = $$props.color,
      color = _$$props$color12 === void 0 ? "#FF3E00" : _$$props$color12;
  var _$$props$unit14 = $$props.unit,
      unit = _$$props$unit14 === void 0 ? "px" : _$$props$unit14;
  var _$$props$duration14 = $$props.duration,
      duration = _$$props$duration14 === void 0 ? "1.25s" : _$$props$duration14;
  var _$$props$size15 = $$props.size,
      size = _$$props$size15 === void 0 ? "60" : _$$props$size15;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var Firework = /*#__PURE__*/function (_SvelteComponent15) {
  _inherits(Firework, _SvelteComponent15);

  var _super15 = _createSuper(Firework);

  function Firework(options) {
    var _this15;

    _classCallCheck(this, Firework);

    _this15 = _super15.call(this);
    if (!document.getElementById("svelte-1x2s7pr-style")) add_css$9();
    init(_assertThisInitialized(_this15), options, instance$9, create_fragment$9, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this15;
  }

  return _createClass(Firework);
}(SvelteComponent);
/* src\Pulse.svelte generated by Svelte v3.38.3 */


function add_css$8() {
  var style = element("style");
  style.id = "svelte-446r86-style";
  style.textContent = ".wrapper.svelte-446r86{position:relative;display:flex;justify-content:center;align-items:center;width:var(--size);height:calc(var(--size) / 2.5)}.cube.svelte-446r86{position:absolute;top:0px;width:calc(var(--size) / 5);height:calc(var(--size) / 2.5);background-color:var(--color);animation:svelte-446r86-motion var(--duration) cubic-bezier(0.895, 0.03, 0.685, 0.22)\r\n      infinite}@keyframes svelte-446r86-motion{0%{opacity:1}50%{opacity:0}100%{opacity:1}}";
  append(document.head, style);
}

function get_each_context$2(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (45:2) {#each range(3, 0) as version}


function create_each_block$2(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "cube svelte-446r86");
      set_style(div, "animation-delay",
      /*version*/
      ctx[6] * (+
      /*durationNum*/
      ctx[5] / 10) +
      /*durationUnit*/
      ctx[4]);
      set_style(div, "left",
      /*version*/
      ctx[6] * (+
      /*size*/
      ctx[3] / 3 + +
      /*size*/
      ctx[3] / 15) +
      /*unit*/
      ctx[1]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "left",
        /*version*/
        ctx[6] * (+
        /*size*/
        ctx[3] / 3 + +
        /*size*/
        ctx[3] / 15) +
        /*unit*/
        ctx[1]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$8(ctx) {
  var div;
  var each_value = range(3, 0);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i24 = 0; _i24 < each_blocks.length; _i24 += 1) {
        each_blocks[_i24].c();
      }

      attr(div, "class", "wrapper svelte-446r86");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i25 = 0; _i25 < each_blocks.length; _i25 += 1) {
        each_blocks[_i25].m(div, null);
      }
    },
    p: function p(ctx, _ref31) {
      var _ref32 = _slicedToArray(_ref31, 1),
          dirty = _ref32[0];

      if (dirty &
      /*range, durationNum, durationUnit, size, unit*/
      58) {
        each_value = range(3, 0);

        var _i26;

        for (_i26 = 0; _i26 < each_value.length; _i26 += 1) {
          var child_ctx = get_each_context$2(ctx, each_value, _i26);

          if (each_blocks[_i26]) {
            each_blocks[_i26].p(child_ctx, dirty);
          } else {
            each_blocks[_i26] = create_each_block$2(child_ctx);

            each_blocks[_i26].c();

            each_blocks[_i26].m(div, null);
          }
        }

        for (; _i26 < each_blocks.length; _i26 += 1) {
          each_blocks[_i26].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$8($$self, $$props, $$invalidate) {
  var _$$props$color13 = $$props.color,
      color = _$$props$color13 === void 0 ? "#FF3E00" : _$$props$color13;
  var _$$props$unit15 = $$props.unit,
      unit = _$$props$unit15 === void 0 ? "px" : _$$props$unit15;
  var _$$props$duration15 = $$props.duration,
      duration = _$$props$duration15 === void 0 ? "1.5s" : _$$props$duration15;
  var _$$props$size16 = $$props.size,
      size = _$$props$size16 === void 0 ? "60" : _$$props$size16;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var Pulse = /*#__PURE__*/function (_SvelteComponent16) {
  _inherits(Pulse, _SvelteComponent16);

  var _super16 = _createSuper(Pulse);

  function Pulse(options) {
    var _this16;

    _classCallCheck(this, Pulse);

    _this16 = _super16.call(this);
    if (!document.getElementById("svelte-446r86-style")) add_css$8();
    init(_assertThisInitialized(_this16), options, instance$8, create_fragment$8, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this16;
  }

  return _createClass(Pulse);
}(SvelteComponent);
/* src\Jellyfish.svelte generated by Svelte v3.38.3 */


function add_css$7() {
  var style = element("style");
  style.id = "svelte-1v1mfqa-style";
  style.textContent = ".wrapper.svelte-1v1mfqa{position:relative;display:flex;justify-content:center;align-items:center;width:var(--size);height:var(--size)}.ring.svelte-1v1mfqa{position:absolute;border:2px solid var(--color);border-radius:50%;background-color:transparent;animation:svelte-1v1mfqa-motion var(--duration) ease infinite}@keyframes svelte-1v1mfqa-motion{0%{transform:translateY(var(--motionOne))}50%{transform:translateY(var(--motionTwo))}100%{transform:translateY(var(--motionThree))}}";
  append(document.head, style);
}

function get_each_context$1(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (43:2) {#each range(6, 0) as version}


function create_each_block$1(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "ring svelte-1v1mfqa");
      set_style(div, "animation-delay",
      /*version*/
      ctx[6] * (
      /*durationNum*/
      ctx[5] / 25) +
      /*durationUnit*/
      ctx[4]);
      set_style(div, "width",
      /*version*/
      ctx[6] * (+
      /*size*/
      ctx[3] / 6) +
      /*unit*/
      ctx[1]);
      set_style(div, "height",
      /*version*/
      ctx[6] * (+
      /*size*/
      ctx[3] / 6) / 2 +
      /*unit*/
      ctx[1]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "width",
        /*version*/
        ctx[6] * (+
        /*size*/
        ctx[3] / 6) +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "height",
        /*version*/
        ctx[6] * (+
        /*size*/
        ctx[3] / 6) / 2 +
        /*unit*/
        ctx[1]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$7(ctx) {
  var div;
  var each_value = range(6, 0);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
  }

  return {
    c: function c() {
      div = element("div");

      for (var _i27 = 0; _i27 < each_blocks.length; _i27 += 1) {
        each_blocks[_i27].c();
      }

      attr(div, "class", "wrapper svelte-1v1mfqa");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--motionOne", -
      /*size*/
      ctx[3] / 5 +
      /*unit*/
      ctx[1]);
      set_style(div, "--motionTwo", +
      /*size*/
      ctx[3] / 4 +
      /*unit*/
      ctx[1]);
      set_style(div, "--motionThree", -
      /*size*/
      ctx[3] / 5 +
      /*unit*/
      ctx[1]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);

      for (var _i28 = 0; _i28 < each_blocks.length; _i28 += 1) {
        each_blocks[_i28].m(div, null);
      }
    },
    p: function p(ctx, _ref33) {
      var _ref34 = _slicedToArray(_ref33, 1),
          dirty = _ref34[0];

      if (dirty &
      /*range, durationNum, durationUnit, size, unit*/
      58) {
        each_value = range(6, 0);

        var _i29;

        for (_i29 = 0; _i29 < each_value.length; _i29 += 1) {
          var child_ctx = get_each_context$1(ctx, each_value, _i29);

          if (each_blocks[_i29]) {
            each_blocks[_i29].p(child_ctx, dirty);
          } else {
            each_blocks[_i29] = create_each_block$1(child_ctx);

            each_blocks[_i29].c();

            each_blocks[_i29].m(div, null);
          }
        }

        for (; _i29 < each_blocks.length; _i29 += 1) {
          each_blocks[_i29].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--motionOne", -
        /*size*/
        ctx[3] / 5 +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--motionTwo", +
        /*size*/
        ctx[3] / 4 +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--motionThree", -
        /*size*/
        ctx[3] / 5 +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$7($$self, $$props, $$invalidate) {
  var _$$props$color14 = $$props.color,
      color = _$$props$color14 === void 0 ? "#FF3E00" : _$$props$color14;
  var _$$props$unit16 = $$props.unit,
      unit = _$$props$unit16 === void 0 ? "px" : _$$props$unit16;
  var _$$props$duration16 = $$props.duration,
      duration = _$$props$duration16 === void 0 ? "2.5s" : _$$props$duration16;
  var _$$props$size17 = $$props.size,
      size = _$$props$size17 === void 0 ? "60" : _$$props$size17;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var Jellyfish = /*#__PURE__*/function (_SvelteComponent17) {
  _inherits(Jellyfish, _SvelteComponent17);

  var _super17 = _createSuper(Jellyfish);

  function Jellyfish(options) {
    var _this17;

    _classCallCheck(this, Jellyfish);

    _this17 = _super17.call(this);
    if (!document.getElementById("svelte-1v1mfqa-style")) add_css$7();
    init(_assertThisInitialized(_this17), options, instance$7, create_fragment$7, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this17;
  }

  return _createClass(Jellyfish);
}(SvelteComponent);
/* src\Chasing.svelte generated by Svelte v3.38.3 */


function add_css$6() {
  var style = element("style");
  style.id = "svelte-1unnvn6-style";
  style.textContent = ".wrapper.svelte-1unnvn6{height:var(--size);width:var(--size);display:flex;justify-content:center;align-items:center}.spinner.svelte-1unnvn6{height:var(--size);width:var(--size);animation:svelte-1unnvn6-rotate var(--duration) infinite linear}.dot.svelte-1unnvn6{width:60%;height:60%;display:inline-block;position:absolute;top:0;background-color:var(--color);border-radius:100%;animation:svelte-1unnvn6-bounce var(--duration) infinite ease-in-out}@keyframes svelte-1unnvn6-rotate{100%{transform:rotate(360deg)}}@keyframes svelte-1unnvn6-bounce{0%,100%{transform:scale(0)}50%{transform:scale(1)}}";
  append(document.head, style);
}

function get_each_context(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[6] = list[i];
  return child_ctx;
} // (55:4) {#each range(2, 0) as version}


function create_each_block(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "dot svelte-1unnvn6");
      set_style(div, "animation-delay",
      /*version*/
      ctx[6] === 1 ? "".concat(
      /*durationNum*/
      ctx[5] / 2).concat(
      /*durationUnit*/
      ctx[4]) : "0s");
      set_style(div, "bottom",
      /*version*/
      ctx[6] === 1 ? "0" : "");
      set_style(div, "top",
      /*version*/
      ctx[6] === 1 ? "auto" : "");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function create_fragment$6(ctx) {
  var div1;
  var div0;
  var each_value = range(2, 0);
  var each_blocks = [];

  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
  }

  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");

      for (var _i30 = 0; _i30 < each_blocks.length; _i30 += 1) {
        each_blocks[_i30].c();
      }

      attr(div0, "class", "spinner svelte-1unnvn6");
      attr(div1, "class", "wrapper svelte-1unnvn6");
      set_style(div1, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div1, "--color",
      /*color*/
      ctx[0]);
      set_style(div1, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);

      for (var _i31 = 0; _i31 < each_blocks.length; _i31 += 1) {
        each_blocks[_i31].m(div0, null);
      }
    },
    p: function p(ctx, _ref35) {
      var _ref36 = _slicedToArray(_ref35, 1),
          dirty = _ref36[0];

      if (dirty &
      /*range, durationNum, durationUnit*/
      48) {
        each_value = range(2, 0);

        var _i32;

        for (_i32 = 0; _i32 < each_value.length; _i32 += 1) {
          var child_ctx = get_each_context(ctx, each_value, _i32);

          if (each_blocks[_i32]) {
            each_blocks[_i32].p(child_ctx, dirty);
          } else {
            each_blocks[_i32] = create_each_block(child_ctx);

            each_blocks[_i32].c();

            each_blocks[_i32].m(div0, null);
          }
        }

        for (; _i32 < each_blocks.length; _i32 += 1) {
          each_blocks[_i32].d(1);
        }

        each_blocks.length = each_value.length;
      }

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div1, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div1, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div1, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div1);
      destroy_each(each_blocks, detaching);
    }
  };
}

function instance$6($$self, $$props, $$invalidate) {
  var _$$props$color15 = $$props.color,
      color = _$$props$color15 === void 0 ? "#FF3E00" : _$$props$color15;
  var _$$props$unit17 = $$props.unit,
      unit = _$$props$unit17 === void 0 ? "px" : _$$props$unit17;
  var _$$props$duration17 = $$props.duration,
      duration = _$$props$duration17 === void 0 ? "2s" : _$$props$duration17;
  var _$$props$size18 = $$props.size,
      size = _$$props$size18 === void 0 ? "60" : _$$props$size18;
  var durationUnit = duration.match(durationUnitRegex)[0];
  var durationNum = duration.replace(durationUnitRegex, "");

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, durationUnit, durationNum];
}

var Chasing = /*#__PURE__*/function (_SvelteComponent18) {
  _inherits(Chasing, _SvelteComponent18);

  var _super18 = _createSuper(Chasing);

  function Chasing(options) {
    var _this18;

    _classCallCheck(this, Chasing);

    _this18 = _super18.call(this);
    if (!document.getElementById("svelte-1unnvn6-style")) add_css$6();
    init(_assertThisInitialized(_this18), options, instance$6, create_fragment$6, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this18;
  }

  return _createClass(Chasing);
}(SvelteComponent);
/* src\Shadow.svelte generated by Svelte v3.38.3 */


function add_css$5() {
  var style = element("style");
  style.id = "svelte-tycttu-style";
  style.textContent = ".wrapper.svelte-tycttu{position:relative;display:flex;justify-content:center;align-items:center;width:var(--size);height:var(--size)}.shadow.svelte-tycttu{color:var(--color);font-size:var(--size);overflow:hidden;width:var(--size);height:var(--size);border-radius:50%;margin:28px auto;position:relative;transform:translateZ(0);animation:svelte-tycttu-load var(--duration) infinite ease,\r\n      svelte-tycttu-round var(--duration) infinite ease}@keyframes svelte-tycttu-load{0%{box-shadow:0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,\r\n        0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em}5%,95%{box-shadow:0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,\r\n        0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em}10%,59%{box-shadow:0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em,\r\n        -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em,\r\n        -0.297em -0.775em 0 -0.477em}20%{box-shadow:0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em,\r\n        -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em,\r\n        -0.749em -0.34em 0 -0.477em}38%{box-shadow:0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em,\r\n        -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em,\r\n        -0.82em -0.09em 0 -0.477em}100%{box-shadow:0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em,\r\n        0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em}}@keyframes svelte-tycttu-round{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}";
  append(document.head, style);
}

function create_fragment$5(ctx) {
  var div1;
  var div0;
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      attr(div0, "class", "shadow svelte-tycttu");
      attr(div1, "class", "wrapper svelte-tycttu");
      set_style(div1, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div1, "--color",
      /*color*/
      ctx[0]);
      set_style(div1, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
    },
    p: function p(ctx, _ref37) {
      var _ref38 = _slicedToArray(_ref37, 1),
          dirty = _ref38[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div1, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div1, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div1, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div1);
    }
  };
}

function instance$5($$self, $$props, $$invalidate) {
  var _$$props$color16 = $$props.color,
      color = _$$props$color16 === void 0 ? "#FF3E00" : _$$props$color16;
  var _$$props$unit18 = $$props.unit,
      unit = _$$props$unit18 === void 0 ? "px" : _$$props$unit18;
  var _$$props$duration18 = $$props.duration,
      duration = _$$props$duration18 === void 0 ? "1.7s" : _$$props$duration18;
  var _$$props$size19 = $$props.size,
      size = _$$props$size19 === void 0 ? "60" : _$$props$size19;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var Shadow = /*#__PURE__*/function (_SvelteComponent19) {
  _inherits(Shadow, _SvelteComponent19);

  var _super19 = _createSuper(Shadow);

  function Shadow(options) {
    var _this19;

    _classCallCheck(this, Shadow);

    _this19 = _super19.call(this);
    if (!document.getElementById("svelte-tycttu-style")) add_css$5();
    init(_assertThisInitialized(_this19), options, instance$5, create_fragment$5, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this19;
  }

  return _createClass(Shadow);
}(SvelteComponent);
/* src\Square.svelte generated by Svelte v3.38.3 */


function add_css$4() {
  var style = element("style");
  style.id = "svelte-btmyrn-style";
  style.textContent = ".square.svelte-btmyrn{height:var(--size);width:var(--size);background-color:var(--color);animation:svelte-btmyrn-squareDelay var(--duration) 0s infinite\r\n      cubic-bezier(0.09, 0.57, 0.49, 0.9);animation-fill-mode:both;perspective:100px;display:inline-block}@keyframes svelte-btmyrn-squareDelay{25%{-webkit-transform:rotateX(180deg) rotateY(0);transform:rotateX(180deg) rotateY(0)}50%{-webkit-transform:rotateX(180deg) rotateY(180deg);transform:rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:rotateX(0) rotateY(180deg);transform:rotateX(0) rotateY(180deg)}100%{-webkit-transform:rotateX(0) rotateY(0);transform:rotateX(0) rotateY(0)}}";
  append(document.head, style);
}

function create_fragment$4(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      attr(div, "class", "square svelte-btmyrn");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, _ref39) {
      var _ref40 = _slicedToArray(_ref39, 1),
          dirty = _ref40[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function instance$4($$self, $$props, $$invalidate) {
  var _$$props$color17 = $$props.color,
      color = _$$props$color17 === void 0 ? "#FF3E00" : _$$props$color17;
  var _$$props$unit19 = $$props.unit,
      unit = _$$props$unit19 === void 0 ? "px" : _$$props$unit19;
  var _$$props$duration19 = $$props.duration,
      duration = _$$props$duration19 === void 0 ? "3s" : _$$props$duration19;
  var _$$props$size20 = $$props.size,
      size = _$$props$size20 === void 0 ? "60" : _$$props$size20;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var Square = /*#__PURE__*/function (_SvelteComponent20) {
  _inherits(Square, _SvelteComponent20);

  var _super20 = _createSuper(Square);

  function Square(options) {
    var _this20;

    _classCallCheck(this, Square);

    _this20 = _super20.call(this);
    if (!document.getElementById("svelte-btmyrn-style")) add_css$4();
    init(_assertThisInitialized(_this20), options, instance$4, create_fragment$4, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this20;
  }

  return _createClass(Square);
}(SvelteComponent);
/* src\Moon.svelte generated by Svelte v3.38.3 */


function add_css$3() {
  var style = element("style");
  style.id = "svelte-nlgli4-style";
  style.textContent = ".wrapper.svelte-nlgli4{height:var(--size);width:var(--size);border-radius:100%;animation:svelte-nlgli4-moonStretchDelay var(--duration) 0s infinite linear;animation-fill-mode:forwards;position:relative}.circle-one.svelte-nlgli4{top:var(--moonSize);background-color:var(--color);width:calc(var(--size) / 7);height:calc(var(--size) / 7);border-radius:100%;animation:svelte-nlgli4-moonStretchDelay var(--duration) 0s infinite linear;animation-fill-mode:forwards;opacity:0.8;position:absolute}.circle-two.svelte-nlgli4{opacity:0.1;border:calc(var(--size) / 7) solid var(--color);height:var(--size);width:var(--size);border-radius:100%;box-sizing:border-box}@keyframes svelte-nlgli4-moonStretchDelay{100%{transform:rotate(360deg)}}";
  append(document.head, style);
}

function create_fragment$3(ctx) {
  var div2;
  var div0;
  var t;
  var div1;
  return {
    c: function c() {
      div2 = element("div");
      div0 = element("div");
      t = space();
      div1 = element("div");
      attr(div0, "class", "circle-one svelte-nlgli4");
      attr(div1, "class", "circle-two svelte-nlgli4");
      attr(div2, "class", "wrapper svelte-nlgli4");
      set_style(div2, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div2, "--color",
      /*color*/
      ctx[0]);
      set_style(div2, "--moonSize",
      /*top*/
      ctx[4] +
      /*unit*/
      ctx[1]);
      set_style(div2, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div2, t);
      append(div2, div1);
    },
    p: function p(ctx, _ref41) {
      var _ref42 = _slicedToArray(_ref41, 1),
          dirty = _ref42[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div2, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div2, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*unit*/
      2) {
        set_style(div2, "--moonSize",
        /*top*/
        ctx[4] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div2, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div2);
    }
  };
}

function instance$3($$self, $$props, $$invalidate) {
  var _$$props$color18 = $$props.color,
      color = _$$props$color18 === void 0 ? "#FF3E00" : _$$props$color18;
  var _$$props$unit20 = $$props.unit,
      unit = _$$props$unit20 === void 0 ? "px" : _$$props$unit20;
  var _$$props$duration20 = $$props.duration,
      duration = _$$props$duration20 === void 0 ? "0.6s" : _$$props$duration20;
  var _$$props$size21 = $$props.size,
      size = _$$props$size21 === void 0 ? "60" : _$$props$size21;
  var moonSize = +size / 7;
  var top = +size / 2 - moonSize / 2;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size, top];
}

var Moon = /*#__PURE__*/function (_SvelteComponent21) {
  _inherits(Moon, _SvelteComponent21);

  var _super21 = _createSuper(Moon);

  function Moon(options) {
    var _this21;

    _classCallCheck(this, Moon);

    _this21 = _super21.call(this);
    if (!document.getElementById("svelte-nlgli4-style")) add_css$3();
    init(_assertThisInitialized(_this21), options, instance$3, create_fragment$3, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this21;
  }

  return _createClass(Moon);
}(SvelteComponent);
/* src\Plane.svelte generated by Svelte v3.38.3 */


function add_css$2() {
  var style = element("style");
  style.id = "svelte-1sqavxm-style";
  style.textContent = ".wrapper.svelte-1sqavxm.svelte-1sqavxm{height:var(--size);width:var(--size);position:relative;display:flex;justify-content:center;align-items:center}.wrapper.svelte-1sqavxm .svelte-1sqavxm{line-height:0;box-sizing:border-box}.spinner-inner.svelte-1sqavxm.svelte-1sqavxm{height:var(--size);width:var(--size);transform:scale(calc(var(--size) / 70))}.mask.svelte-1sqavxm.svelte-1sqavxm{position:absolute;border-radius:2px;overflow:hidden;perspective:1000;backface-visibility:hidden}.plane.svelte-1sqavxm.svelte-1sqavxm{background:var(--color);width:400%;height:100%;position:absolute;z-index:100;perspective:1000;backface-visibility:hidden}#top.svelte-1sqavxm .plane.svelte-1sqavxm{z-index:2000;animation:svelte-1sqavxm-trans1 var(--duration) ease-in infinite 0s backwards}#middle.svelte-1sqavxm .plane.svelte-1sqavxm{transform:translate3d(0px, 0, 0);background:var(--rgba);animation:svelte-1sqavxm-trans2 var(--duration) linear infinite calc(var(--duration) / 4)\r\n      backwards}#bottom.svelte-1sqavxm .plane.svelte-1sqavxm{z-index:2000;animation:svelte-1sqavxm-trans3 var(--duration) ease-out infinite\r\n      calc(var(--duration) / 2) backwards}#top.svelte-1sqavxm.svelte-1sqavxm{width:53px;height:20px;left:20px;top:5px;transform:skew(-15deg, 0);z-index:100}#middle.svelte-1sqavxm.svelte-1sqavxm{width:33px;height:20px;left:20px;top:21px;transform:skew(-15deg, 40deg)}#bottom.svelte-1sqavxm.svelte-1sqavxm{width:53px;height:20px;top:35px;transform:skew(-15deg, 0)}@keyframes svelte-1sqavxm-trans1{from{transform:translate3d(53px, 0, 0)}to{transform:translate3d(-250px, 0, 0)}}@keyframes svelte-1sqavxm-trans2{from{transform:translate3d(-160px, 0, 0)}to{transform:translate3d(53px, 0, 0)}}@keyframes svelte-1sqavxm-trans3{from{transform:translate3d(53px, 0, 0)}to{transform:translate3d(-220px, 0, 0)}}";
  append(document.head, style);
}

function create_fragment$2(ctx) {
  var div7;
  var div6;
  return {
    c: function c() {
      div7 = element("div");
      div6 = element("div");
      div6.innerHTML = "<div id=\"top\" class=\"mask svelte-1sqavxm\"><div class=\"plane svelte-1sqavxm\"></div></div> \n    <div id=\"middle\" class=\"mask svelte-1sqavxm\"><div class=\"plane svelte-1sqavxm\"></div></div> \n    <div id=\"bottom\" class=\"mask svelte-1sqavxm\"><div class=\"plane svelte-1sqavxm\"></div></div>";
      attr(div6, "class", "spinner-inner svelte-1sqavxm");
      attr(div7, "class", "wrapper svelte-1sqavxm");
      set_style(div7, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div7, "--color",
      /*color*/
      ctx[0]);
      set_style(div7, "--rgba",
      /*rgba*/
      ctx[4]);
      set_style(div7, "--duration",
      /*duration*/
      ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, div7, anchor);
      append(div7, div6);
    },
    p: function p(ctx, _ref43) {
      var _ref44 = _slicedToArray(_ref43, 1),
          dirty = _ref44[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div7, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div7, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*rgba*/
      16) {
        set_style(div7, "--rgba",
        /*rgba*/
        ctx[4]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div7, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div7);
    }
  };
}

function instance$2($$self, $$props, $$invalidate) {
  var _$$props$color19 = $$props.color,
      color = _$$props$color19 === void 0 ? "#FF3E00" : _$$props$color19;
  var _$$props$unit21 = $$props.unit,
      unit = _$$props$unit21 === void 0 ? "px" : _$$props$unit21;
  var _$$props$duration21 = $$props.duration,
      duration = _$$props$duration21 === void 0 ? "1.3s" : _$$props$duration21;
  var _$$props$size22 = $$props.size,
      size = _$$props$size22 === void 0 ? "60" : _$$props$size22;
  var rgba;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*color*/
    1) {
      $$invalidate(4, rgba = calculateRgba(color, 0.6));
    }
  };

  return [color, unit, duration, size, rgba];
}

var Plane = /*#__PURE__*/function (_SvelteComponent22) {
  _inherits(Plane, _SvelteComponent22);

  var _super22 = _createSuper(Plane);

  function Plane(options) {
    var _this22;

    _classCallCheck(this, Plane);

    _this22 = _super22.call(this);
    if (!document.getElementById("svelte-1sqavxm-style")) add_css$2();
    init(_assertThisInitialized(_this22), options, instance$2, create_fragment$2, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this22;
  }

  return _createClass(Plane);
}(SvelteComponent);
/* src\Diamonds.svelte generated by Svelte v3.38.3 */


function add_css$1() {
  var style = element("style");
  style.id = "svelte-evhfle-style";
  style.textContent = "span.svelte-evhfle{width:var(--size);height:calc(var(--size) / 4);position:relative;display:block}div.svelte-evhfle{width:calc(var(--size) / 4);height:calc(var(--size) / 4);position:absolute;left:0;top:0;border-radius:2px;background:var(--color);transform:translateX(-50%) rotate(45deg) scale(0);animation:svelte-evhfle-diamonds var(--duration) linear infinite}div.svelte-evhfle:nth-child(1){animation-delay:calc(var(--duration) * 2 / 3 * -1)}div.svelte-evhfle:nth-child(2){animation-delay:calc(var(--duration) * 2 / 3 * -2)}div.svelte-evhfle:nth-child(3){animation-delay:calc(var(--duration) * 2 / 3 * -3)}@keyframes svelte-evhfle-diamonds{50%{left:50%;transform:translateX(-50%) rotate(45deg) scale(1)}100%{left:100%;transform:translateX(-50%) rotate(45deg) scale(0)}}";
  append(document.head, style);
}

function create_fragment$1(ctx) {
  var span;
  var div0;
  var t0;
  var div1;
  var t1;
  var div2;
  return {
    c: function c() {
      span = element("span");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      div2 = element("div");
      attr(div0, "class", "svelte-evhfle");
      attr(div1, "class", "svelte-evhfle");
      attr(div2, "class", "svelte-evhfle");
      set_style(span, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(span, "--color",
      /*color*/
      ctx[0]);
      set_style(span, "--duration",
      /*duration*/
      ctx[2]);
      attr(span, "class", "svelte-evhfle");
    },
    m: function m(target, anchor) {
      insert(target, span, anchor);
      append(span, div0);
      append(span, t0);
      append(span, div1);
      append(span, t1);
      append(span, div2);
    },
    p: function p(ctx, _ref45) {
      var _ref46 = _slicedToArray(_ref45, 1),
          dirty = _ref46[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(span, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(span, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(span, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(span);
    }
  };
}

function instance$1($$self, $$props, $$invalidate) {
  var _$$props$color20 = $$props.color,
      color = _$$props$color20 === void 0 ? "#FF3E00" : _$$props$color20;
  var _$$props$unit22 = $$props.unit,
      unit = _$$props$unit22 === void 0 ? "px" : _$$props$unit22;
  var _$$props$duration22 = $$props.duration,
      duration = _$$props$duration22 === void 0 ? "1.5s" : _$$props$duration22;
  var _$$props$size23 = $$props.size,
      size = _$$props$size23 === void 0 ? "60" : _$$props$size23;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var Diamonds = /*#__PURE__*/function (_SvelteComponent23) {
  _inherits(Diamonds, _SvelteComponent23);

  var _super23 = _createSuper(Diamonds);

  function Diamonds(options) {
    var _this23;

    _classCallCheck(this, Diamonds);

    _this23 = _super23.call(this);
    if (!document.getElementById("svelte-evhfle-style")) add_css$1();
    init(_assertThisInitialized(_this23), options, instance$1, create_fragment$1, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this23;
  }

  return _createClass(Diamonds);
}(SvelteComponent);
/* src\Clock.svelte generated by Svelte v3.38.3 */


function add_css() {
  var style = element("style");
  style.id = "svelte-1cgj772-style";
  style.textContent = "div.svelte-1cgj772{position:relative;width:var(--size);height:var(--size);background-color:transparent;box-shadow:inset 0px 0px 0px 2px var(--color);border-radius:50%}div.svelte-1cgj772::before,div.svelte-1cgj772:after{position:absolute;content:\"\";background-color:var(--color)}div.svelte-1cgj772:after{width:calc(var(--size) / 2.4);height:2px;top:calc(var(--size) / 2);left:calc(var(--size) / 2);transform-origin:1px 1px;animation:svelte-1cgj772-rotate calc(var(--duration) / 4) linear infinite}div.svelte-1cgj772:before{width:calc(var(--size) / 3);height:2px;top:calc((var(--size) / 2));left:calc((var(--size) / 2));transform-origin:1px 1px;animation:svelte-1cgj772-rotate var(--duration) linear infinite}@keyframes svelte-1cgj772-rotate{100%{transform:rotate(360deg)}}";
  append(document.head, style);
}

function create_fragment(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      set_style(div, "--size",
      /*size*/
      ctx[3] +
      /*unit*/
      ctx[1]);
      set_style(div, "--color",
      /*color*/
      ctx[0]);
      set_style(div, "--duration",
      /*duration*/
      ctx[2]);
      attr(div, "class", "svelte-1cgj772");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    p: function p(ctx, _ref47) {
      var _ref48 = _slicedToArray(_ref47, 1),
          dirty = _ref48[0];

      if (dirty &
      /*size, unit*/
      10) {
        set_style(div, "--size",
        /*size*/
        ctx[3] +
        /*unit*/
        ctx[1]);
      }

      if (dirty &
      /*color*/
      1) {
        set_style(div, "--color",
        /*color*/
        ctx[0]);
      }

      if (dirty &
      /*duration*/
      4) {
        set_style(div, "--duration",
        /*duration*/
        ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}

function instance($$self, $$props, $$invalidate) {
  var _$$props$color21 = $$props.color,
      color = _$$props$color21 === void 0 ? "#FF3E00" : _$$props$color21;
  var _$$props$unit23 = $$props.unit,
      unit = _$$props$unit23 === void 0 ? "px" : _$$props$unit23;
  var _$$props$duration23 = $$props.duration,
      duration = _$$props$duration23 === void 0 ? "8s" : _$$props$duration23;
  var _$$props$size24 = $$props.size,
      size = _$$props$size24 === void 0 ? "60" : _$$props$size24;

  $$self.$$set = function ($$props) {
    if ("color" in $$props) $$invalidate(0, color = $$props.color);
    if ("unit" in $$props) $$invalidate(1, unit = $$props.unit);
    if ("duration" in $$props) $$invalidate(2, duration = $$props.duration);
    if ("size" in $$props) $$invalidate(3, size = $$props.size);
  };

  return [color, unit, duration, size];
}

var Clock = /*#__PURE__*/function (_SvelteComponent24) {
  _inherits(Clock, _SvelteComponent24);

  var _super24 = _createSuper(Clock);

  function Clock(options) {
    var _this24;

    _classCallCheck(this, Clock);

    _this24 = _super24.call(this);
    if (!document.getElementById("svelte-1cgj772-style")) add_css();
    init(_assertThisInitialized(_this24), options, instance, create_fragment, safe_not_equal, {
      color: 0,
      unit: 1,
      duration: 2,
      size: 3
    });
    return _this24;
  }

  return _createClass(Clock);
}(SvelteComponent);

export { BarLoader, Chasing, Circle, Circle2, Circle3, Clock, Diamonds, DoubleBounce, Firework, GoogleSpin, Jellyfish, Jumper, Moon, Plane, Pulse, Rainbow, RingLoader, ScaleOut, Shadow, SpinLine, Square, Stretch, SyncLoader, Wave };